import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SmartModule as EducationalContentModule } from '@com-delta-idp/mnx-skymiles-educational-content';
import { MilesRolloverPageComponent } from '@com-delta-idp/mnx-skymiles-miles-rollover-ui';
import {
  SummaryModule as OverviewSummaryModule,
  StipulationModule
} from '@com-delta-idp/mnx-skymiles-shared';
import {
  ModalComponent,
  SkeletonLoaderDirective,
  TrackerComponent
} from '@com-delta-omnichannel/aura';
import {
  BenefitsModule,
  CardCarouselModule,
  EarnsSummaryModule,
  MicroMomentsModule,
  OnboardingModule,
  QuickLinksModule,
  SnapshotModule,
  SummaryModule,
  UpgradesModule
} from '../../features';
import { SkyClubTrackerComponent } from '../../features/skyclub/skyclub-tracker/sky-club-tracker.component';
import { EarnsModule } from '../earns/earns.module';
import { OverviewPageComponent } from './overview-page.component';
@NgModule({
  declarations: [OverviewPageComponent],
  imports: [
    CommonModule,
    OnboardingModule,
    MicroMomentsModule,
    SummaryModule,
    QuickLinksModule,
    BenefitsModule,
    SnapshotModule,
    UpgradesModule,
    EarnsModule,
    SkeletonLoaderDirective,
    StipulationModule,
    OverviewSummaryModule,
    TrackerComponent,
    CardCarouselModule,
    EarnsSummaryModule,
    ModalComponent,
    EducationalContentModule,
    MilesRolloverPageComponent,
    SkyClubTrackerComponent
  ],
  exports: [OverviewPageComponent]
})
export class OverviewPageModule {}
